import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {ProgressBar} from '@/components/ui/progress-bar/ProgressBar'
import {UserCheck02Icon, UserX02Icon} from '@/components/ui/icon/Icon'
import {useTheme} from 'styled-components'
import {useTranslation} from '@/translations/i18n'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const CompletedAccessesSectionEmptyState = ({isLoading}: {isLoading: boolean}) => {
    const {t} = useTranslation()
    const {palette} = useTheme()

    return (
        <Flexbox direction="column" gap={3} fullWidth>
            {isLoading ? (
                <>
                    <Skeleton width="100%" height={40} />
                    <Skeleton width="100%" height={40} />
                </>
            ) : (
                <>
                    <Flexbox direction="column" gap={1} fullWidth>
                        <Flexbox fullWidth gap={0.5} direction="row" align="center">
                            <UserCheck02Icon size={18} color={palette.neutral[400]} />
                            <Text palette="neutral" shade="500" size="textSm">
                                {t('projects:performed_in_presence')}
                            </Text>
                        </Flexbox>
                        <Flexbox fullWidth gap={0.5} direction="column" align="end">
                            <Text palette="neutral" shade="500" size="textSm">
                                -
                            </Text>
                            <ProgressBar percentage={0} rounded variant="neutral" />
                        </Flexbox>
                    </Flexbox>

                    <Flexbox direction="column" gap={1} fullWidth>
                        <Flexbox fullWidth gap={0.5} direction="row" align="center">
                            <UserX02Icon size={18} color={palette.neutral[400]} />
                            <Text palette="neutral" shade="500" size="textSm">
                                {t('projects:performed_in_absence')}
                            </Text>
                        </Flexbox>
                        <Flexbox fullWidth gap={0.5} direction="column" align="end">
                            <Text palette="neutral" shade="500" size="textSm">
                                -
                            </Text>
                            <ProgressBar percentage={0} rounded variant="neutral" />
                        </Flexbox>
                    </Flexbox>
                </>
            )}
        </Flexbox>
    )
}
